import { render, staticRenderFns } from "./smartico-widget-navigation-item.vue?vue&type=template&id=cbd6ec7c&scoped=true&"
import script from "./smartico-widget-navigation-item.vue?vue&type=script&lang=ts&"
export * from "./smartico-widget-navigation-item.vue?vue&type=script&lang=ts&"
import style0 from "./smartico-widget-navigation-item.vue?vue&type=style&index=0&id=cbd6ec7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd6ec7c",
  null
  
)

component.options.__file = "smartico-widget-navigation-item.vue"
export default component.exports